import React, { useState, useEffect, useRef } from 'react';
import { MdPrint } from 'react-icons/md';
import { getPrinters, submitFilePrintJob } from '../../api/printJobs';
import '../common/PrintButton.css';

const CAN_PRINT = new Set(['admin', 'engineer', 'manager', 'foreman', 'team-leader']);

export default function FilePrintButton({ fileId, isPersonal, role }) {
  const [open,    setOpen]    = useState(false);
  const [printers, setPrinters] = useState(null);
  const [sending, setSending] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open || printers !== null) return;
    getPrinters().then(r => setPrinters(r.data)).catch(() => setPrinters([]));
  }, [open, printers]);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const handlePrint = async (printer) => {
    setOpen(false);
    setSending(true);
    try {
      await submitFilePrintJob({ fileId, fileType: isPersonal ? 'personal' : 'project', printer });
    } catch (err) {
      console.error('Print failed:', err);
    } finally {
      setSending(false);
    }
  };

  if (!CAN_PRINT.has(role)) return null;

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button className="fl-btn-icon" title="Print" disabled={sending} onClick={() => setOpen(v => !v)}>
        <MdPrint size={14} />
      </button>
      {open && (
        <div className="print-settings-panel" style={{ right: 0 }}>
          {printers === null && <p className="print-menu-muted">Loading printers…</p>}
          {printers !== null && printers.length > 0 && printers.map(p => (
            <button key={p.name} className="print-menu-item" onClick={() => handlePrint(p.name)}>
              <MdPrint size={13} /> {p.displayName || p.name}
            </button>
          ))}
          {printers !== null && printers.length === 0 && (
            <p className="print-menu-muted">No printers available</p>
          )}
        </div>
      )}
    </div>
  );
}
